// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"607":"349e57cf","4015":"4110ad00","4695":"4a5beb25","9613":"4a5beb25"}[chunkId] + ".chunk.css";
};